/* eslint-disable max-len */
/* eslint-disable max-lines */
const features = [
  { 
    id: 'green-roof', 
    tooltipId: 'green-roof-tooltip',
    tooltip: 'Green roof',
    x: 48, 
    y: 20, 
    description: 'Living roofs that absorb rainwater and provide insulation',
    iconColor: '#4a7c59',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'bioretention', 
    tooltipId: 'bioretention-tooltip',
    tooltip: 'Bioretention cell',
    x: 48, 
    y: 52, 
    description: 'Landscaped depressions that collect and filter stormwater',
    iconColor: '#7fb069',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'filter-strip', 
    tooltipId: 'filter-strip-tooltip',
    tooltip: 'Filter strip',
    x: 3, 
    y: 56, 
    description: 'Vegetated areas that filter runoff from impervious surfaces',
    iconColor: '#2d5016',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'vegetated-swale', 
    tooltipId: 'vegetated-swale-tooltip',
    tooltip: 'Vegetated swale',
    x: 18, 
    y: 62, 
    description: 'Shallow channels designed to convey and treat stormwater runoff',
    iconColor: '#5a8a3a',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'permeable-paving', 
    tooltipId: 'permeable-paving-tooltip',
    tooltip: 'Permeable paving',
    x: 25, 
    y: 65, 
    description: 'Porous surfaces that allow water to infiltrate into the ground',
    iconColor: '#696969',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'rainwater-tank', 
    tooltipId: 'rainwater-tank-tooltip',
    tooltip: 'Rainwater harvesting tank',
    x: 40, 
    y: 71, 
    description: 'Storage systems for collecting and reusing rainwater',
    iconColor: '#0367A5',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'constructed-wetland', 
    tooltipId: 'constructed-wetland-tooltip',
    tooltip: 'Constructed wetland',
    x: 66, 
    y: 64, 
    description: 'Engineered systems that mimic natural wetlands for water treatment',
    iconColor: '#4a90e2',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'wet-pond', 
    tooltipId: 'wet-pond-tooltip',
    tooltip: 'Wet pond',
    x: 76, 
    y: 56, 
    description: 'Permanent pools that provide stormwater treatment and detention',
    iconColor: '#4a90e2',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'trees', 
    tooltipId: 'trees-tooltip',
    tooltip: 'Trees',
    x: 86, 
    y: 42, 
    description: 'Urban canopy that intercepts rainfall and reduces runoff',
    iconColor: '#2d5016',
    backgroundColor: '#c5dce8ff',
  },
  { 
    id: 'detention-basin', 
    tooltipId: 'detention-basin-tooltip',
    tooltip: 'Vegetated detention basin',
    x: 32, 
    y: 52, 
    description: 'Temporary storage areas that slowly release stormwater',
    iconColor: '#7fb069',
    backgroundColor: '#c5dce8ff',
  },
];

const contents = [
  {
    id: 'rainwater-tank', 
    img: 'img/blue-green/1.webp',
    largeImg: 'img/blue-green-large/Figure01.jpg',
    name: 'Rainwater harvesting tank',
    objectives: 'Rainwater harvesting systems are designed to retain rainwater from roofs and use it for non-potable purposes such as irrigation of green areas, flushing toilets, etc.',
    description: 'Residential rainwater harvesting is a retention practice that aids in runoff reduction. This type of rainwater harvesting is relatively affordable and easy to install. Rain barrels and other collection tanks and cisterns are available in many sizes and shapes to fit homeowner’s needs. They can be designed as ornamental garden accents, dynamic water features that activate during and after storm events, or as understated utilitarian water storage tanks. Depending on the size and type of construction, we distinguish: 1) above-ground tanks, which usually have a volume between 0.2 – 2 m3 and 2) underground tanks, which usually have a volume between 2 – 10 m3. Rainwater harvesting systems should be sized appropriately to capture and store an adequate supply of rainwater. If not used frequently, rainwater storage devices may need to be drained to prevent stagnation and odors. The roofing material from which rainwater is harvested must be considered when establishing its end use. The source of pollution is atmospheric deposition, nearby vegetation (e.g. leaves) and animal excrement. Therefore, it is necessary to ensure the removal of larger particles, such as leaves, with a catch net on the gutter. Due to washing away fine particles at the beginning of precipitation, a first-rinse diverter is installed on the vertical of the gutter, which leads the water past the collector (tank).',
    hydrological_functions: [
      'Retention',
      'Runoff reduction',
    ],
    advantages: [
      'Low-cost measure.',
      'Additional source for irrigation or non-potable use.',
    ],
    limitations: [
      'As a flood control measure, it is difficult to foresee that the reservoir will be empty when it rains.',
      'For larger systems, automatic drains are required.',
    ],
    maintenance: [
      'Regular cleaning of gutters, nets, filters. Removal of sediment.',
      'Inspection for leaks, blockages, or mosquito breeding risks.',
    ],
    recommendations: [
      'Design an efficient system:',
      'Use gutters and downpipes to channel water from roofs;',
      'Include first-flush diverters to discard initial runoff (which may be polluted); Install filters to remove debris and contaminants;',
      'Choose storage materials (e.g., plastic, concrete, or metal tanks) based on climate, budget, and intended use.',
    ],
  },
  {
    id: 'permeable-paving', 
    img: 'img/blue-green/2.webp',
    largeImg: 'img/blue-green-large/Figure02.jpg',
    name: 'Permeable paving',
    objectives: 'Permeable pavements provide a stabilised surface for pedestrians and/or vehicles, allowing rainwater to infiltrate through the surface into the underground layers.',
    description: 'Rainwater is temporarily retained in the underground layer, infiltrates into the loose terrain or is drained off by drainage. Depending on the type of materials used, a distinction is made between permeable materials that allow infiltration over the entire surface (e.g. permeable pavements, porous concrete/asphalt) and impermeable materials with intermediate openings/slots (e.g. grass nets, impermeable pavements).',
    hydrological_functions: [
      'Retention and infiltration allow for the reduction of surface runoff from paved surfaces. Water retention in the subsurface layer allows evaporative cooling.',
      'Filtration and sedimentation.',
    ],
    advantages: ['Implementation in areas that would otherwise be impermeable.'],
    limitations: [
      'Not suitable for locations where hazardous substances are expected (near factories, warehouses, etc.) or where there is a lot of sediment.',
      'Pre-treatment (sedimentation and/or filtration) must be provided if surface inflow is from more congested areas.',
      'In water protection areas, with limitation of sedimentation, a bottom sealing design is possible.',
      'Parking lots sloped greater than 5% require special consideration for subsurface grading and drainage.',
    ],
    maintenance: ['Ensuring the permeability of the surface layer: 1) regular removal of leaves and sediment, 2) vacuum washing, presumably once a year, after the autumn leaf fall.'],
    recommendations: [
      'Before installation, a site assessment is needed:',
      'Soil infiltration rate (e.g., sandy soil is ideal)',
      'Water table depth (at least 60–90 cm below base)',
      'Slope (less than 5% is ideal to avoid runoff)',
      'Ensuring the permeability of the surface layer: 1) regular removal of leaves and sediment, 2) vacuum washing, presumably once a year, after the autumn leaf falls.',
      'Design the system properly: 1) Include a layered sub-base (crushed stone or gravel) to store and infiltrate water. 2) Provide geotextile fabric to separate soil from base materials and prevent clogging. 3) Design for runoff volume and load - larger areas or higher traffic need deeper and stronger bases.',
    ],
  },
  {
    id: 'green-roof', 
    img: 'img/blue-green/3.webp',
    largeImg: 'img/blue-green-large/Figure03.jpg',
    name: 'Green roof',
    objectives: 'Green roofs are areas with living vegetation that are established on the roofs of buildings to provide aesthetic and biological value, increase the efficiency of the building (insulation) and reduce surface runoff.',
    description: 'Vegetated roofs (green roofs) provide the benefits of a garden on top of buildings. Vegetated roofs reduce runoff through processes of retention and evapotranspiration most effectively from short, mild storm events. Studies have shown that in temperate climates, vegetated roofs are capable of reducing annual roof runoff by 50 percent. They can be classified as extensive and intensive types and consist of soil media, plant materials, and a range of insulation and waterproofing membranes. Depending on the thickness of the growing substrate, two types of green roofs are distinguished: extensive (growing substrate 20 - 150 mm) and intensive (growing substrate > 150 mm). Intensive vegetated roofs sustain more diverse plant palettes, including shrubs and trees, and may be designed as rooftop gardens meant for human habitation.',
    hydrological_functions: [
      'Reduction of surface runoff, retention, evapotranspiration and evaporative cooling.',
      'Filtration and biological treatment.',
    ],
    advantages: [
      'Providing green spaces in urbanized areas that increase the aesthetic and biological value of the area.',
      'Intensive roofs are usually accessible to people and can provide additional habitable amenity space (for relaxation and rest).',
      'Additional insulation of the building reduces energy consumption (heating and cooling).',
    ],
    limitations: [
      'Load-bearing capacity of the roof structure; More expensive than conventional roofs.',
      'Irrigation of intensive roofs during drought (rainwater harvesting).',
    ],
    maintenance: [
      'Intensive (planted with mosses, succulents, sedges, herbs): require minimal maintenance, e.g. annual removal of dead plant parts.',
      'Extensive (planted with grasses, shrubs, trees and herbs): require regular maintenance and irrigation (depending on the climate).',
    ],
    recommendations: [
      'Requires adequate roof structure; consult with a structural engineer for both new construction and potential retrofit applications.',
      'Choose appropriate green roof systems and plant species for your local climate to reduce irrigation needs and support local biodiversity.',
    ],
  },
  {
    id: 'trees', 
    img: 'img/blue-green/4.webp',
    largeImg: 'img/blue-green-large/Figure04.jpg',
    name: 'Tree',
    objectives: 'Trees in urban environments provide a variety of hydrological, environmental and social functions. ',
    description: 'To ensure the greatest possible range of functions, it is necessary to provide appropriate conditions for tree growth. Since above-ground and underground space (infrastructure) in settlements is limited, a structural cell can provide appropriate load-bearing conditions for (permeability) pressure on the surface and at the same time ensure soil aeration (prevent soil compaction). This provides space for root growth in the horizontal direction and water infiltration in the vertical direction. Tree boxes can vary in design, material, and cost based on available area and orientation of subsurface structures and utilities. This makes tree boxes an ideal measure for dense urban areas where paved surfaces are necessary. ',
    hydrological_functions: [
      'Reduction of surface runoff (rainfall interception), retention, infiltration, evapotranspiration and evaporative cooling. ',
      'Sedimentation, filtration, biological treatment. ',
    ],
    advantages: [
      'Ensuring the full range of environmental and social benefits brought by trees (reduction of urban heat island and noise, better air quality, biodiversity, aesthetic value). ',
      'Soil aeration or preventing soil compaction. ',
    ],
    limitations: [
      'The tree should not be the lowest point of the surrounding terrain (excessive accumulation of sediments and pollutants). ',
      'Placement next to the existing municipal infrastructure. ',
    ],
    maintenance: ['Regular removal of garbage and sediment, soil aeration.'],
    recommendations: [
      'Tree boxes can be implemented in dense urban areas.',
      'Research and choose trees appropriate to site cultural conditions.',
      'Provide grate over root zone if implemented in high foot traffic areas.',
      'Avoid low spots. ',
      'Urban-resilient tree species and tolerant to drought, salt, and compaction, with compatible root structure (non-invasive, deep-rooted). ',
      'Dimensions of surface area and depth: usually 1,2 – 32,4 m wide, 1 – 1,2 m deep; larger boxes increase stormwater and ecological performance. ',
    ],
  },
  {
    id: 'bioretention', 
    img: 'img/blue-green/5.webp',
    largeImg: 'img/blue-green-large/Figure05.jpg',
    name: 'Bioretention cell',
    objectives: 'Bioretention cells are small depressions into which the surface runoff flows directly from the surrounding paved surfaces via inlets (e.g., curbs with a gap).',
    description: 'The inlet is followed by a calming part of depression, which ensures sedimentation - preventing soil clogging and preventing erosion. Then, the water is temporarily retained in the surface layer and slowly infiltrates into the soil. In the soil layer or growth substrate, moisture-loving plants are planted, which contribute to the treatment of rainwater through uptake into plant biomass, filtration and stabilization of pollutants in the root zone. Then, the water percolates or passes from the soil to the retention layer, from where the purified water is discharged via drainage or exfiltration into the cultivated terrain. Common implementations of bioretention cells include streetscapes and along urban plazas.',
    hydrological_functions: [
      'Reduction of surface runoff, retention, infiltration, evapotranspiration.',
      'Sedimentation, percolation, filtration and biological treatment.',
    ],
    advantages: [
      'Provides additional pervious surfaces.',
      'Pollutant removal (TSS > 90%; TP > 80%; N ≈ 50%; Zn, Pb, Cd > 90%, Cu < 60%).',
      'Aesthetic value, biodiversity, improves air quality, educational opportunity',
    ],
    limitations: [
      'The contributing area should be less than 0.8 ha.',
      'BRE generally occupies 2-4% of the catchment area.',
      'Hydraulically designed only for high frequency rainfall.',
    ],
    maintenance: ['Regular maintenance or after heavy rains: removal of trash and sediment, inspection of inflows and outflows.'],
    recommendations: [
      'Locate at least 0,6 m above groundwater table.',
      'Site slope should be less than 20%; bioretention cells on sites with slopes greater than 20% should be terraced.',
      'Native or adaptive plant species with tolerance to wet-dry cycles; mix of grasses, shrubs, and perennials for biodiversity.',
    ],
  },
  {
    id: 'detention-basin', 
    img: 'img/blue-green/6.webp',
    largeImg: 'img/blue-green-large/Figure06.jpg',
    name: 'Vegetated detention basin',
    objectives: 'Detention/infiltration basins (also called dry basins) are open systems – shallow depressions with a flat bottom, under which a retention layer of gravel or sand is located.',
    description: 'To improve the ability of water to pass from the surface to the retention layer, the surface of the basin can be made of sand or gravel, or the surface of the retention basin can be planted with grass. Such basins are dry most of the time, filled with water only during and after precipitation events. Their main function is to regulate the peak of surface runoff. Vegetated detention basins detain large volumes of stormwater, aiding in peak flow reduction and mitigation of potential downstream flooding. Detaining stormwater in vegetated basins also enables sediment removal as vegetation decreases stormwater velocity, allowing suspended solids to settle out. Vegetated detention basins provide the additional benefits of increased aesthetic appeal, wildlife habitat, and improved air quality.',
    hydrological_functions: [
      'Reduction of surface runoff peak, temporary detention and infiltration.',
      'Sedimentation and filtration enable the retention of pollutants from the first downpour, while vegetation ensures filtration and biological treatment.',
    ],
    advantages: [
      'Wildlife habitat, aesthetic quality, provides additional pervious surfaces, improves air quality',
      'With appropriate landscaping (e.g. gentle slopes of the banks), they can be a functional part of green areas.',
    ],
    limitations: [
      'Size: approximately 1-3% of the catchment area.',
      'The maximum depth should not exceed 2 m.',
      'Recommended slope of the banks 1:3.',
    ],
    maintenance: [
      'Annual sediment removal and mowing.',
      'Inspect inlet/outlet for blockages such as plant debris/litter after storm events.',
    ],
    recommendations: [
      'They must be emptied after each rainfall (for mosquito control).',
      'Size: Approximately 1-3% of drainage area.',
      'Inspect for underlying karst geology.',
      'Locate at least 0,6 m above groundwater table.',
      'Needs differential inlet and outlet elevation.',
      'Locate in full sun.',
    ],
  },
  {
    id: 'wet-pond', 
    img: 'img/blue-green/7.webp',
    largeImg: 'img/blue-green-large/Figure07.jpg',
    name: 'Wet pond',
    objectives: 'A wet pond is a constructed basin designed to retain a permanent pool of stormwater with limited biological treatment.',
    description: 'Ponds or wet detention basins are features with a permanent water surface provided by a low permeable or impermeable bottom and a suitable outlet angle. The retention volume is the difference between the volume at a constant and the highest water level. The dimensions of the retention volume depend on the expected inflows (e.g. stream and rainfall) and losses (evapotranspiration, infiltration). To ensure adequate water quality in the basin, it is necessary to ensure adequate water quality at the inlet and adequate continuity of the water inflow. The basin undergoes sedimentation of fine particles, biological treatment with aquatic plants and photogradation, which is why they are suitable for the final treatment of surface runoff from settlements before it is discharged into natural water bodies.',
    hydrological_functions: [
      'Reduction of surface runoff peak, permanent retention, evapotranspiration and evaporative cooling.',
      'Sedimentation, filtration, biological treatment and photodegradation.',
    ],
    advantages: [
      'They provide evaporatively cool environments.',
      'Aesthetic value, biodiversity.',
      'Alternative water source (e.g. fire water).',
    ],
    limitations: [
      'Adequate inflow quality (limit sediments and nutrients – no fertilizer uses in the area) to reduce sedimentation and the likelihood of eutrophication.',
      'Improper maintenance can lead to eutrophication and water stagnation.',
    ],
    maintenance: [
      'Annual sediment removal and mowing.',
      'Inspect inlet/outlet for blockages such as plant debris/litter after storm events',
      'Pond aeration often required.',
    ],
    recommendations: [
      'Fertilizers should not be used near wet ponds as excess nutrients increase algae growth that may lead to eutrophication.',
      'Requires base flow to prevent stagnation.',
      'A water fountain significantly improves water aeration.',
      'To ensure public safety, research local codes concerning standing waterbodies.',
    ],
  },
  {
    id: 'constructed-wetland', 
    img: 'img/blue-green/8.webp',
    largeImg: 'img/blue-green-large/Figure08.jpg',
    name: 'Constructed wetland',
    objectives: 'Constructed wetlands are shallow, vegetated depressions with permanent standing water that offer a spectrum of ecosystem services to manage and treat stormwater.',
    description: 'The high diversity of plants, animals and microorganisms ensures a high level of treatment through biological, physical (sedimentation, filtration) and chemical (oxidation, photodegradation) processes. They can be used as treatment plants before discharge into natural water bodies. Constructed wetlands should maintain a constant shallow water level, therefore it is recommended to build slightly above the permanent groundwater level. The natural aesthetic quality and high potential for habitat make constructed wetlands an excellent choice for educational opportunities. Constructed wetlands should maintain a shallow permanent level of water at all times and therefore should be located close to the water table. This makes constructed wetlands an appropriate measure choice for persistently wet areas. They can receive water from an extensive drainage area; a minimum of 10 acres drainage area up to 25 acres drainage area is preferable, however, smaller “pocket wetlands” or bog gardens may be used in low, wet areas of smaller sites. Pretreating stormwater before it enters the constructed wetland will decrease maintenance needed to remove sediment that may eventually clog the wetland.',
    hydrological_functions: [
      'Reduction of surface runoff peak, evapotranspiration.',
      'Sedimentation, percolation, filtration, biological treatment and photodegradation.',
    ],
    advantages: [
      'They provide evaporative cooling of the environment.',
      'Aesthetic value, biodiversity, educational activity, recreation.',
      'Suitable for larger catchment areas.',
    ],
    limitations: [
      'Expensive implementation.',
      'Inadequate maintenance can lead to eutrophication and biomass decay.',
      'The gentle slopes of planted banks (1:3 – 1:4) require large areas.',
    ],
    maintenance: [
      'Periodic removal of trash and sediment.',
      'Annual maintenance: limiting unwanted plants (invasive species).',
      'Replacing soil after 5-10 years if too much pollution accumulates.',
    ],
    recommendations: [
      'Applicable to large drainage areas.',
      'High educational opportunity; good for school yards.',
      'Safety challenges posed by standing water need to be considered and addressed.',
      'Locate in full sun.',
    ],
  },
  {
    id: 'vegetated-swale', 
    img: 'img/blue-green/9.webp',
    largeImg: 'img/blue-green-large/Figure09.jpg',
    name: 'Vegetated swale',
    objectives: 'Vegetated swales, also known as bioswales, are gently sloped, planted channels for treating and conveying stormwater.',
    description: 'They are used as a linear element that collects surface runoff from linear paved surfaces (roads, sidewalks, parking lots). They differ from conventional channeling systems as they combine conveyance with stormwater treatment. In contrast to concrete-lined swales and pipes that are impervious, costly to install and maintain, and convey water quickly, vegetated swales slow stormwater velocity, allow for evapotranspiration, and remove debris while enhancing sediment drop-out and infiltration. Their effectiveness in treating stormwater runoff is directly related to the diversity and density of planting. Vegetated swales are often located along roads or parking lots or in other linear applications such as landscape buffers near property lines. Vegetated swales may contain dense native plantings, turf grasses, or a combination of both. Their effectiveness is directly correlated to their size and vegetation density, with larger, more densely vegetated swales providing higher degrees of treatment. Due to the greater roughness of the surface, they contribute to a significant slowdown of surface runoff, compared to pipes and channels made of artificial materials. Amended soil and gravel may be necessary to increase infiltration rates in areas with poorly draining or compacted soils. Additionally, an underdrain and overflow device may be required to prevent stormwater runoff from entering adjacent areas during larger storms. Depending on the variety of planting and maintenance of the water level, we distinguish between grass swales (most of the time dry) and swales with moisture-loving vegetation (most of the time wet).',
    hydrological_functions: [
      'Slowing down surface runoff, evapotranspiration, infiltration.',
      'Sedimentation, percolation, filtration, biological treatment.',
    ],
    advantages: [
      'They replace sewers (pipes and manholes).',
      'Easy to implement and place in existing green belts.',
    ],
    limitations: ['An outlet facility that will prevent uncontrolled spillage in the event of extreme rainfall.'],
    maintenance: [
      'Regular maintenance or after heavy rains: removal of trash and sediment, inspection of inflows and outflows.',
      'Maintain vegetation and soil stability.',
    ],
    recommendations: [
      'Locate at least 0,6 m above groundwater table.',
      'Ideal for sites with less than a 1-2% slope. At higher slopes, it is necessary to regulate the water level and water flow speed by leveling the longitudinal profile or smaller transverse barriers with spillways.',
    ],
  },
  {
    id: 'filter-strip', 
    img: 'img/blue-green/10.webp',
    largeImg: 'img/blue-green-large/Figure10.jpg',
    name: 'Filter strip',
    objectives: 'Filter strips are gently sloping banks with vegetation that slow surface runoff and allow suspended solids to drop out of stormwater runoff.',
    description: "Filter strips employ wide areas of dense, native vegetation to slow stormwater, allowing for sediment drop-out, filtration, and debris removal before runoff enters receiving waters. They can be used as a riparian belt that protects a watercourse from fast and warmer surface runoff from parking lots, roads or roofs. Filter strips utilizing native vegetation are mowed less often than traditional lawns, so converting a space from conventional turf to a native filter strip reduces maintenance. Alter strips' low maintenance requirements make them one of the least expensive types of stormwater runoff mitigation. Ideally, a filter strip should be equal in size to the impervious area it serves, making this measure appropriate for large, open sites, such as along greenway corridors. However, smaller strips of lawn or plantings may be used to slow runoff before it enters another blue-green measure such as a vegetated swale or flows across permeable pavement. Filter strips utilizing native vegetation are mowed less often than traditional lawns, so converting a space from conventional turf to a native filter strip reduces maintenance. Filter strips’ low maintenance requirements make them one of the least expensive types of stormwater runoff mitigation.",
    hydrological_functions: [
      'Slowing down surface runoff.',
      'Straining, filtration, sedimentation.',
    ],
    advantages: ['Low cost of arrangement and maintenance.'],
    limitations: [
      'Slope < 50%.',
      'Size: 50-100% of the contributing areas (e.g. parking lot, road, roof).',
      'They are not suitable for highly urbanized areas as they require large areas.',
    ],
    maintenance: [
      'Part of the filter strip along the catchment areas: regular removal of garbage and sediments and mowing of grass.',
      'Part of the filter strip along the watercourse: mowed only at the end of winter - low maintenance.',
      'Inspection of the filter strip for possible signs of improper operation, such as erosion, water stagnation, sedimentation, soil compaction.',
    ],
    recommendations: ['Despite the simple technology, it requires a lot of attention in planning, as most operational problems occur due to inadequate planning: 1) blockage at the interface between the impervious surfaces and the filter belt, 2) too large/too small a slope of the terrain or too small a vertical jump at the interface between the impervious surfaces and the filter belt, 3) stable groundcover must be maintained to ensure proper functioning of filter strip.'],
  },
]

export {
  features,
  contents,
}